var _defs, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #033047;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #e3ff00;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.2,77.97l5.31-8.74,6.29,3.84,2.64-4.34-19.31-11.76-2.64,4.34,6.3,3.84-5.03,8.27c-7.37-4.48-15.81-7.35-24.85-8.12v-18.88h9.34v-6.42h-28.61v6.42h9.32v18.88c-29.41,2.52-52.49,27.18-52.49,57.24,0,31.74,25.73,57.46,57.47,57.46s57.46-25.72,57.46-57.46c0-17.98-8.26-34.04-21.2-44.57ZM264.92,144.19l-6.71-4.09-2.96,4.86,6.64,4.04c-7.73,10.77-20.06,18.03-34.11,18.9v-7.5h-5.68v7.5c-12.4-.76-23.45-6.5-31.2-15.24l6.14-4.67-3.44-4.53-6.18,4.72c-5-7.3-7.92-16.14-7.92-25.65,0-7.44,1.79-14.47,4.96-20.68l7.22,4.4,2.96-4.86-7.26-4.42c7.67-11.27,20.29-18.91,34.74-19.8v8.78h5.68v-8.78c12.76.79,24.1,6.85,31.86,16.02l-6.8,5.17,3.45,4.53,6.76-5.15c4.65,7.13,7.35,15.64,7.35,24.79,0,7.84-1.99,15.21-5.48,21.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.78,104.97v-11.86h-5.69v11.86c-8.49,1.36-14.98,8.7-14.98,17.57,0,9.84,7.98,17.82,17.82,17.82s17.82-7.98,17.82-17.82c0-8.87-6.49-16.21-14.98-17.57Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 224.94,
    cy: 122.54,
    r: 10.84
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.46368c0f9adb448a6d8474c01b6214d5.svg";
export { ForwardRef as ReactComponent };